<iframe id="grafana" [src]="this.linkGrafana | safe" frameborder="0"></iframe>
